<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-11-10 11:39:12
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Form_ApprovalTriger.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-12 11:17:04
-->
<template>
  <v-alert
    border="left"
    color="primary"
    rounded-lg
    :class="ContainerClass"
    colored-border
    height="40"
  >
    <v-sheet
      height="40"
      class="
        align-center
        d-flex
        align-self-center
        fill-height
        pl-4
        rounded-lg
        text--secondary text-caption
        justify-space-between
      "
    >
      <slot name="time" />
    </v-sheet>
    <template v-slot:append>
      <div class="text-right d-flex align-center px-1">
        <!-- <v-sheet
          height="18"
          class="pl-1 rounded rounded-r-lg mx-2"
          :color="slideColor"
        >
          <v-sheet
            class="
              rounded-r
              px-2
              text-caption-xs
              fill-height
              align-center
              d-flex
            "
            :color="bgColor"
          >
           
          </v-sheet>
        </v-sheet> -->
        <v-chip
          small
          v-if="!$store.state.isLoading"
          class="mx-2"
          label
          :style="{ borderLeft: '8px solid ' + slideColor }"
          :color="bgColor"
        >
          <slot name="status" />
        </v-chip>
        <v-btn
          icon
          color="primary"
          small
          v-if="triger"
          :disabled="$store.state.isLoading"
          @click="$emit('triger')"
        >
          <span class="material-icons-round">{{ trigerIcon }}</span>
        </v-btn>
      </div>
    </template>
  </v-alert>
</template>
<script>
export default {
  name: "ApprovalTriger",
  props: {
    elevation: { default: 0, type: [String, Number] },
    hidden: { default: false, type: [Boolean, Number, Object, String, Array] },
    triger: { default: true, type: [Boolean, Number] },
    trigerIcon: { default: "keyboard_arrow_right", type: String },
    slideColor: { default: "white", type: [String, Number] },
    bgColor: { default: "white", type: [String, Number] },
    ContainerClass: {
      default: " mb-8 pa-0",
      type: [String],
    },
  },
  data() {
    return {};
  },
};
</script>